<template>
<div v-loading="isLoading">
  <EventsOptions @eventSelected="(event) => (eventSelectedId = event)"/>
  <button
    @click="handleCommand()"
    :disabled="eventSelectedId === ''"
    class="btn btn-danger btn-fill btn-wd"
    title="Este botão remove tudo relacionado a um evento"
  >
    Remover tudo relacionado ao evento.
  </button>
  <input
    id="checkbox-force-delete-event"
    type="checkbox"
    v-model="forceDelete"
  >
  <label for="checkbox-force-delete-event">Forçar a remoção permanentemente</label>
</div>
</template>

<script>
import EventsOptions from 'src/components/EventsOptions.vue'
import CouchdbClass from 'src/services/CouchdbClass'
import swal from 'sweetalert2'

export default {
  name: 'RemoveAllAboutAnEvent',
  components: {
    EventsOptions
  },

  data: () => ({
    eventSelectedId: '',
    forceDelete: false,
    isLoading: false
  }),

  computed: {
    eventDb: () => {
      return new CouchdbClass({ connection: 'default', collection: 'events' })
    },
    customerDb: () => {
      return new CouchdbClass({ connection: 'default', collection: 'customers' })
    },
    ticketDb: () => {
      return new CouchdbClass({ connection: 'default', collection: 'tickets' })
    },
    lampDb: () => {
      return new CouchdbClass({ connection: 'default', collection: 'lamps' })
    },
    stockDb: () => {
      return new CouchdbClass({ connection: 'default', collection: 'stocks' })
    },
    docDb: () => {
      return new CouchdbClass({ connection: 'docs', collection: 'docs' })
    }
  },

  methods: {
    async handleCommand () {
      await swal({
        title: 'Removendo Tickets',
        message: 'Aguarde',
        type: 'info',
        confirmButtonText: 'Remover',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.deleteTickets()
        }
      }).then(async () => {
        await swal({
          title: 'Removendo Docs',
          message: 'Aguarde',
          type: 'info',
          confirmButtonText: 'Remover',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCloseButton: true,
          showConfirmButton: true,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            await this.deleteDocs()
          }
        }).then(async () => {
          await swal({
            title: 'Removendo lamps',
            message: 'Aguarde',
            type: 'info',
            confirmButtonText: 'Remover',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCloseButton: true,
            showConfirmButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              await this.deleteLamps()
            }
          }).then(async () => {
            await swal({
              title: 'Removendo stocks',
              message: 'Aguarde',
              type: 'info',
              confirmButtonText: 'Remover',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              showCloseButton: true,
              showConfirmButton: true,
              showLoaderOnConfirm: true,
              preConfirm: async () => {
                await this.deleteStocks()
              }
            }).then(async () => {
              await swal({
                title: 'Removendo Evento',
                message: 'Aguarde',
                type: 'info',
                confirmButtonText: 'Remover',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showCloseButton: true,
                showConfirmButton: true,
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                  await this.deleteEvents()
                }
              })
            })
          })
        })
      })
    },
    async deleteEvents () {
      let event = await this.eventDb.find(this.eventSelectedId)
      event.deletedAt = new Date()
      if (this.forceDelete) {
        await this.eventDb.delete(event._id, true)
        return
      }
      await this.eventDb.upsert(event._id, event)
    },
    async deleteData (couchdb) {
      let data = this.forceDelete ? await couchdb
        .where('eventId', this.eventSelectedId)
        .withTrash()
        .get() : await couchdb
        .where('eventId', this.eventSelectedId)
        .get()

      if (this.forceDelete) {
        const deleteData = data.map(item => JSON.parse(JSON.stringify({
          _id: item._id,
          _rev: item._rev,
          _deleted: true
        })))
        await couchdb._updateBulkDocs(deleteData)
        return data
      }

      couchdb._updateBulkDocs(data.map(item => Object.assign(item, { deletedAt: new Date() })))
      return data
    },
    async deleteTickets () {
      let tickets = await this.deleteData(this.ticketDb)
      await this.deleteCustomers(tickets.map(item => item.customerId))
    },
    async deleteLamps () {
      let lamps = await this.deleteData(this.lampDb)
      await this.deleteCustomers(lamps.map(item => item.customer.id))
    },
    async deleteCustomers (customersId) {
      let customers = await this.customerDb._bulkGet(customersId)
      if (this.forceDelete) {
        for (let customer of customers) {
          await this.customerDb.delete(customer._id, true)
        }
        return true
      }
      return this.customerDb._updateBulkDocs(
        customers.map(item => Object.assign(item, { deletedAt: new Date() }))
      )
    },
    async deleteStocks () {
      await this.deleteData(this.stockDb)
    },
    async deleteDocs () {
      let docs = await this.docDb.where('referenceId', this.eventSelectedId).get()
      for (let doc of docs) {
        this.docDb.delete(doc._id, true)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/commands/RemoveAllAboutAnEvent.vue